import React from 'react'
import PropTypes from 'prop-types'
import { withRouter, Switch as RouterSwitch } from 'react-router-dom'
import PrivateRoute from '../../../hocs/PrivateRoute'
import BroadcastList from './List'
import BroadcastCompose from './Compose'
import RecipientSelect from './RecipientSelect'
import BroadcastDetail from './Detail'

// Routes for the Broadcasts module (spec: broadcast-messages). Order matters: the more specific
// `/:id/recipients` must precede `/:id` so it isn't shadowed.
const BroadcastsRoutes = props => (
  <RouterSwitch>
    <PrivateRoute exact path={props.match.path} component={BroadcastList} />
    <PrivateRoute exact path={`${props.match.path}/new`} component={BroadcastCompose} />
    <PrivateRoute
      exact
      path={`${props.match.path}/:id/recipients`}
      component={RecipientSelect}
    />
    <PrivateRoute
      exact
      path={`${props.match.path}/:id/compose`}
      component={BroadcastCompose}
    />
    <PrivateRoute exact path={`${props.match.path}/:id`} component={BroadcastDetail} />
  </RouterSwitch>
)

BroadcastsRoutes.propTypes = {
  match: PropTypes.object
}

export default withRouter(BroadcastsRoutes)
